import React, { createContext, useState, useEffect, useContext } from 'react';

const ErrorMonitorContext = createContext();

export const useErrorMonitor = () => useContext(ErrorMonitorContext);

export const ErrorMonitorProvider = ({ children }) => {
    const [failedCount, setFailedCount] = useState(0);

    useEffect(() => {
        const handleFailures = (event) => {
            setFailedCount(event.detail); // Update failedCount when event is dispatched
        };

        window.addEventListener('consecutiveFailures', handleFailures);

        return () => {
            window.removeEventListener('consecutiveFailures', handleFailures);
        };
    }, []);

    return (
        <ErrorMonitorContext.Provider value={{ failedCount, setFailedCount }}>
            {children}
        </ErrorMonitorContext.Provider>
    );
};
